import { Controller } from '@hotwired/stimulus'

// Live "réactivable dans …" countdown for a signer's reminder cooldown chip.
// The server stays authoritative on the cooldown; once it elapses we simply
// reveal the pre-rendered "Relancer" button so the admin can act right away.
// The remaining-time format mirrors SignersCardComponent#format_remaining.
export default class extends Controller {
  static targets = ['chip', 'button', 'remaining']
  static values = { deadline: String }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const remainingMs = new Date(this.deadlineValue).getTime() - Date.now()
    if (remainingMs <= 0) {
      this.reveal()
      return
    }
    if (this.hasRemainingTarget) {
      this.remainingTarget.textContent = this.format(
        Math.ceil(remainingMs / 1000)
      )
    }
  }

  reveal() {
    clearInterval(this.timer)
    // Inline display beats the .inline-flex utility class (which otherwise
    // wins over .hidden by source order), so the chip reliably disappears.
    if (this.hasChipTarget) this.chipTarget.style.display = 'none'
    if (this.hasButtonTarget) this.buttonTarget.classList.remove('hidden')
  }

  format(seconds) {
    if (seconds >= 3600) {
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      return `${hours} h ${String(minutes).padStart(2, '0')}`
    }
    if (seconds >= 60) {
      return `${Math.floor(seconds / 60)} min`
    }
    return `${seconds} s`
  }
}
